import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
  size?: 'sm' | 'md' | 'lg';
}

export default function MovieCard({ movie, size = 'md' }: MovieCardProps) {
  const imageSize = size === 'lg' ? 'h-[420px]' : size === 'sm' ? 'h-[260px]' : 'h-[320px]';

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative ${imageSize} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={movie.image}
          alt={`${movie.title} - 丫丫影院在线观看`}
          title={`${movie.title} - 丫丫影院在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>

        {movie.isHot && (
          <span className="absolute top-2.5 left-2.5 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
            热门
          </span>
        )}
        {movie.isNew && (
          <span className="absolute top-2.5 right-2.5 bg-accent-500 text-foreground-950 text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
            最新
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <h4 className="text-background-50 text-sm md:text-base font-bold truncate mb-1">
            {movie.title}
          </h4>
          <div className="flex items-center justify-between">
            <span className="text-xs text-background-50/70">{movie.episodes}</span>
            <span className="flex items-center gap-0.5 text-xs text-accent-400">
              <i className="ri-star-fill text-xs"></i>
              {movie.rating}
            </span>
          </div>
        </div>

        <div className="absolute inset-0 bg-primary-500/80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90">
            <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}